import React from 'react';

export const GENERAL_MENU_ICON = (
  <svg width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.166992 0.5V15.5H5.16699V12.5833H6.83366V15.5H11.8337V0.5H0.166992ZM1.83366 2.16667H3.50033V3.83333H1.83366V2.16667ZM5.16699 2.16667H6.83366V3.83333H5.16699V2.16667ZM8.50033 2.16667H10.167V3.83333H8.50033V2.16667ZM1.83366 5.5H3.50033V7.16667H1.83366V5.5ZM5.16699 5.5H6.83366V7.16667H5.16699V5.5ZM8.50033 5.5H10.167V7.16667H8.50033V5.5ZM1.83366 8.83333H3.50033V10.5H1.83366V8.83333ZM5.16699 8.83333H6.83366V10.5H5.16699V8.83333ZM8.50033 8.83333H10.167V10.5H8.50033V8.83333ZM1.83366 12.1667H3.50033V13.8333H1.83366V12.1667ZM8.50033 12.1667H10.167V13.8333H8.50033V12.1667Z"
      fill="#333333"
    />
  </svg>
);

export const DATA_MENU_ICON = (
  <svg width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.99967 0.5C3.31634 0.5 0.333008 1.99167 0.333008 3.83333C0.333008 5.675 3.31634 7.16667 6.99967 7.16667C10.683 7.16667 13.6663 5.675 13.6663 3.83333C13.6663 1.99167 10.683 0.5 6.99967 0.5ZM0.333008 5.5V8C0.333008 9.84167 3.31634 11.3333 6.99967 11.3333C10.683 11.3333 13.6663 9.84167 13.6663 8V5.5C13.6663 7.34167 10.683 8.83333 6.99967 8.83333C3.31634 8.83333 0.333008 7.34167 0.333008 5.5ZM0.333008 9.66667V12.1667C0.333008 14.0083 3.31634 15.5 6.99967 15.5C10.683 15.5 13.6663 14.0083 13.6663 12.1667V9.66667C13.6663 11.5083 10.683 13 6.99967 13C3.31634 13 0.333008 11.5083 0.333008 9.66667Z"
      fill="#333333"
    />
  </svg>
);

export const PRIVACY_MENU_ICON = (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0.833984L0.5 4.16732V9.16732C0.5 13.7923 3.7 18.1173 8 19.1673C12.3 18.1173 15.5 13.7923 15.5 9.16732V4.16732L8 0.833984ZM8 9.99232H13.8333C13.3917 13.4257 11.1 16.484 8 17.4423V10.0007H2.16667V5.25065L8 2.65898V9.99232Z"
      fill="#333333"
    />
  </svg>
);

export const INTEGRATIONS_MENU_ICON = (
  <svg width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.6749 7.7L13.9249 0.825002C13.871 0.726368 13.7914 0.644119 13.6946 0.586921C13.5978 0.529723 13.4874 0.499695 13.3749 0.500002H4.62495C4.51251 0.499695 4.40208 0.529723 4.30528 0.586921C4.20849 0.644119 4.12891 0.726368 4.07494 0.825002L0.324945 7.7C0.27009 7.79501 0.241211 7.90279 0.241211 8.0125C0.241211 8.12221 0.27009 8.22999 0.324945 8.325L4.07494 15.2C4.13211 15.294 4.21307 15.3712 4.30964 15.4239C4.40621 15.4766 4.51498 15.5028 4.62495 15.5H13.3749C13.4874 15.5003 13.5978 15.4703 13.6946 15.4131C13.7914 15.3559 13.871 15.2736 13.9249 15.175L17.6749 8.3C17.7253 8.20802 17.7517 8.10485 17.7517 8C17.7517 7.89515 17.7253 7.79199 17.6749 7.7ZM13.3312 2.375L16.0749 7.375H10.1374L13.3312 2.375ZM8.99994 6.8375L5.76244 1.75H12.2374L8.99994 6.8375ZM4.66869 2.375L7.86244 7.375H1.92494L4.66869 2.375ZM1.92494 8.625H7.86244L4.66869 13.625L1.92494 8.625ZM8.99994 9.1625L12.2374 14.25H5.76244L8.99994 9.1625ZM13.3312 13.625L10.1374 8.625H16.0749L13.3312 13.625Z"
      fill="#333333"
    />
  </svg>
);

export const ACTIONS_MENU_ICON = (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5553 12.7778V12.2222C15.5553 12.0749 15.6138 11.9336 15.718 11.8294C15.8222 11.7252 15.9635 11.6667 16.1108 11.6667C16.2582 11.6667 16.3995 11.7252 16.5037 11.8294C16.6078 11.9336 16.6664 12.0749 16.6664 12.2222V17.7778H17.7775V12.2222C17.777 11.7803 17.6013 11.3567 17.2888 11.0442C16.9764 10.7317 16.5527 10.556 16.1108 10.5556C15.8238 10.5574 15.5423 10.6342 15.2942 10.7783C15.0693 10.4143 14.7111 10.1525 14.296 10.0487C13.8809 9.94495 13.4417 10.0074 13.0719 10.2228C12.9225 9.98486 12.7152 9.78869 12.4694 9.65258C12.2236 9.51647 11.9473 9.44486 11.6664 9.44444C11.4766 9.4464 11.2887 9.48117 11.1108 9.54722V6.66667C11.1108 6.22464 10.9352 5.80072 10.6227 5.48816C10.3101 5.17559 9.88618 5 9.44415 5C9.00212 5 8.5782 5.17559 8.26564 5.48816C7.95308 5.80072 7.77748 6.22464 7.77748 6.66667V12.8361L6.53582 11.9861V11.9867C6.19656 11.7388 5.77615 11.6282 5.35883 11.6771C4.9415 11.7261 4.55807 11.9309 4.28535 12.2505C4.01263 12.5702 3.87075 12.9811 3.88815 13.4009C3.90554 13.8207 4.08092 14.2184 4.37915 14.5144L7.95693 17.7778L8.70526 16.9567L5.16193 13.7244C5.11039 13.6732 5.06952 13.6123 5.04167 13.5451C5.01383 13.478 4.99957 13.406 4.99971 13.3333C4.99971 13.2302 5.02844 13.129 5.08268 13.0413C5.13692 12.9535 5.21453 12.8826 5.30681 12.8364C5.39909 12.7903 5.5024 12.7708 5.60515 12.78C5.70791 12.7893 5.80606 12.827 5.8886 12.8889L8.8886 14.9417V6.66667C8.8886 6.51932 8.94713 6.37802 9.05131 6.27383C9.1555 6.16964 9.29681 6.11111 9.44415 6.11111C9.59149 6.11111 9.7328 6.16964 9.83699 6.27383C9.94117 6.37802 9.99971 6.51932 9.99971 6.66667V12.7778H11.1108V11.1111C11.1108 10.9638 11.1693 10.8225 11.2735 10.7183C11.3777 10.6141 11.519 10.5556 11.6664 10.5556C11.8137 10.5556 11.955 10.6141 12.0592 10.7183C12.1634 10.8225 12.2219 10.9638 12.2219 11.1111V12.7778H13.333V11.6667C13.333 11.5193 13.3916 11.378 13.4958 11.2738C13.5999 11.1696 13.7413 11.1111 13.8886 11.1111C14.0359 11.1111 14.1772 11.1696 14.2814 11.2738C14.3856 11.378 14.4442 11.5193 14.4442 11.6667V12.7778H15.5553Z"
      fill="#333333"
    />
    <path
      d="M16.6671 7.77821H13.3338V6.6671H16.6671V3.33377H3.33377V6.6671H5.55599V7.77821H3.33377C3.03917 7.77792 2.75673 7.66076 2.54842 7.45245C2.34011 7.24414 2.22295 6.9617 2.22266 6.6671V3.33377C2.22295 3.03917 2.34011 2.75673 2.54842 2.54842C2.75673 2.34011 3.03917 2.22295 3.33377 2.22266H16.6671C16.9617 2.22295 17.2441 2.34011 17.4524 2.54842C17.6608 2.75673 17.7779 3.03917 17.7782 3.33377V6.6671C17.7779 6.9617 17.6608 7.24414 17.4524 7.45245C17.2441 7.66076 16.9617 7.77792 16.6671 7.77821Z"
      fill="#333333"
    />
  </svg>
);

export const ADVANCED_MENU_ICON = (
  <svg width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.1339 12.6659L9.06728 6.59919C9.66728 5.06586 9.33394 3.26586 8.06728 1.99919C6.73394 0.665861 4.73394 0.399194 3.13394 1.13253L6.00061 3.99919L4.00061 5.99919L1.06728 3.13253C0.267277 4.73253 0.600611 6.73253 1.93394 8.06586C3.20061 9.33253 5.00061 9.66586 6.53394 9.06586L12.6006 15.1325C12.8673 15.3992 13.2673 15.3992 13.5339 15.1325L15.0673 13.5992C15.4006 13.3325 15.4006 12.8659 15.1339 12.6659Z"
      fill="#333333"
    />
  </svg>
);

export const THREE_DOTS_ICON = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M6.58785 3.3298C6.69724 3.43919 6.84562 3.50065 7.00033 3.50065C7.15504 3.50065 7.30341 3.43919 7.4128 3.3298C7.5222 3.2204 7.58366 3.07203 7.58366 2.91732C7.58366 2.76261 7.5222 2.61424 7.4128 2.50484C7.30341 2.39544 7.15504 2.33398 7.00033 2.33398C6.84562 2.33398 6.69724 2.39544 6.58785 2.50484C6.47845 2.61424 6.41699 2.76261 6.41699 2.91732C6.41699 3.07203 6.47845 3.2204 6.58785 3.3298Z"
      stroke="#4A5568"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.58785 7.41313C6.69724 7.52253 6.84562 7.58398 7.00033 7.58398C7.15504 7.58398 7.30341 7.52253 7.4128 7.41313C7.5222 7.30373 7.58366 7.15536 7.58366 7.00065C7.58366 6.84594 7.5222 6.69757 7.4128 6.58817C7.30341 6.47878 7.15504 6.41732 7.00033 6.41732C6.84562 6.41732 6.69724 6.47878 6.58785 6.58817C6.47845 6.69757 6.41699 6.84594 6.41699 7.00065C6.41699 7.15536 6.47845 7.30373 6.58785 7.41313Z"
      stroke="#4A5568"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.58785 11.4965C6.69724 11.6059 6.84562 11.6673 7.00033 11.6673C7.15504 11.6673 7.30341 11.6059 7.4128 11.4965C7.5222 11.3871 7.58366 11.2387 7.58366 11.084C7.58366 10.9293 7.5222 10.7809 7.4128 10.6715C7.30341 10.5621 7.15504 10.5007 7.00033 10.5007C6.84562 10.5007 6.69724 10.5621 6.58785 10.6715C6.47845 10.7809 6.41699 10.9293 6.41699 11.084C6.41699 11.2387 6.47845 11.3871 6.58785 11.4965Z"
      stroke="#4A5568"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WARNING_CONFIRM_ICON = (
  <svg width="20" height="20" fill="none" className="ml-3">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25685 3.09812C9.02185 1.73812 10.9788 1.73812 11.7428 3.09812L17.3228 13.0181C18.0728 14.3521 17.1098 15.9981 15.5808 15.9981H4.41985C2.88985 15.9981 1.92685 14.3521 2.67685 13.0181L8.25685 3.09812ZM10.9998 12.9991C10.9998 13.2643 10.8945 13.5187 10.707 13.7062C10.5194 13.8938 10.2651 13.9991 9.99985 13.9991C9.73463 13.9991 9.48028 13.8938 9.29274 13.7062C9.10521 13.5187 8.99985 13.2643 8.99985 12.9991C8.99985 12.7339 9.10521 12.4796 9.29274 12.292C9.48028 12.1045 9.73463 11.9991 9.99985 11.9991C10.2651 11.9991 10.5194 12.1045 10.707 12.292C10.8945 12.4796 10.9998 12.7339 10.9998 12.9991ZM9.99985 4.99913C9.73463 4.99913 9.48028 5.10448 9.29274 5.29202C9.10521 5.47955 8.99985 5.73391 8.99985 5.99913V8.99913C8.99985 9.26434 9.10521 9.5187 9.29274 9.70623C9.48028 9.89377 9.73463 9.99913 9.99985 9.99913C10.2651 9.99913 10.5194 9.89377 10.707 9.70623C10.8945 9.5187 10.9998 9.26434 10.9998 8.99913V5.99913C10.9998 5.73391 10.8945 5.47955 10.707 5.29202C10.5194 5.10448 10.2651 4.99913 9.99985 4.99913Z"
      fill="#EB5757"
    />
  </svg>
);

export const ARROW_ICON = (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.292787 9.70643C0.105316 9.5189 0 9.2646 0 8.99943C0 8.73427 0.105316 8.47996 0.292787 8.29243L3.58579 4.99943L0.292787 1.70643C0.110629 1.51783 0.00983372 1.26523 0.0121121 1.00303C0.0143906 0.740833 0.11956 0.49002 0.304968 0.304612C0.490376 0.119204 0.741189 0.014035 1.00339 0.0117566C1.26558 0.00947813 1.51818 0.110273 1.70679 0.292431L5.70679 4.29243C5.89426 4.47996 5.99957 4.73427 5.99957 4.99943C5.99957 5.2646 5.89426 5.5189 5.70679 5.70643L1.70679 9.70643C1.51926 9.8939 1.26495 9.99922 0.999786 9.99922C0.734622 9.99922 0.480314 9.8939 0.292787 9.70643Z"
      fill="#4A5568"
    />
  </svg>
);

export const SUCCESS_UPLOADED = (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 7L5 11L15 1"
      stroke="#219653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FAIL_UPLOAD = (
  <svg className="h-6 w-6 text-red-400" fill="currentColor" viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
      clipRule="evenodd"
    />
  </svg>
);

export const DOWNLOAD = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    />
  </svg>
);

export default GENERAL_MENU_ICON;
